import { useEffect, useRef, useState } from "react"
import { useStore } from "../../stores/store"
import { conversationStore, openConversation, closeConversation, sendMessage } from "../../stores/conversationStore"
import { useTranslations } from "../../lib/translations"

const HIDDEN_KINDS = new Set([]) // could hide system/spans later

export function ChatTab({ agent }) {
  const t = useTranslations()
  const entry = useStore(conversationStore, (s) => s.byAgent[agent.id])
  const [text, setText] = useState("")
  const scroller = useRef(null)

  useEffect(() => {
    openConversation(agent.id).catch(() => {})
    return () => closeConversation(agent.id)
  }, [agent.id])

  // auto-scroll to bottom on new messages
  useEffect(() => {
    if (!scroller.current) return
    scroller.current.scrollTop = scroller.current.scrollHeight
  }, [entry?.messages?.length])

  const messages = (entry?.messages || []).filter((m) => !HIDDEN_KINDS.has(m.kind))
  const sending = entry?.sending

  const submit = async (e) => {
    e?.preventDefault?.()
    if (!text.trim() || sending) return
    const t2 = text
    setText("")
    try { await sendMessage(agent.id, t2) }
    catch (err) { setText(t2); alert(err.message) }
  }

  return (
    <>
      <div className="cm-tabwrap" ref={scroller}>
        {messages.length === 0 && (
          <div className="cm-coming-soon">No messages yet — send the first one below.</div>
        )}
        {messages.map((m) => <Message key={m.id} m={m} agent={agent} />)}
      </div>
      <form className="cm-composer" onSubmit={submit}>
        <input value={text}
               onChange={(e) => setText(e.target.value)}
               placeholder={t("modal.composer.placeholder", { name: agent.name })}
               disabled={sending} />
        <button type="submit" disabled={sending || !text.trim()}>
          {t("modal.composer.send")}
        </button>
      </form>
    </>
  )
}

function Message({ m, agent }) {
  if (m.kind === "user") {
    return (
      <div className="cm-msg me">
        <div className="av">U</div>
        <div className="bub">{m.content}</div>
      </div>
    )
  }
  if (m.kind === "agent") {
    return (
      <div className="cm-msg">
        <div className="av">A</div>
        <div className="bub">{m.content}</div>
      </div>
    )
  }
  // system / tool_use / tool_result — render dimmer
  return (
    <div className={`cm-msg ${m.kind}`}>
      <div className="av">·</div>
      <div className="bub">{m.content || m.kind}</div>
    </div>
  )
}
